import { Modal, Form, Button } from "react-bootstrap";
import { useState, useEffect } from "react";
import "./ContactSalesModal.css";
import { FaUser, FaEnvelope, FaPhoneAlt, FaCommentDots } from "react-icons/fa";
import { InputGroup } from "react-bootstrap";
import { FaCheck } from "react-icons/fa";

const ContactSalesModal = ({ show, onClose }) => {
  const [formErrors, setFormErrors] = useState({
    name: "",
    email: "",
    phone: "",
    project: "",
  });
  const validateField = (field, value) => {
    const cleanValue = value.trimEnd(); // ignore trailing spaces
    let error = "";

    const nameRegex = /^[A-Za-z _-]+$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    const phoneRegex = /^[0-9]{10}$/;

    switch (field) {
      /* ---------- NAME ---------- */
      case "name":
        if (!cleanValue.trim())
          error = "Name is required";
        else if (!nameRegex.test(cleanValue))
          error = "Only AlphaNumerics are allowed.";
        else if (cleanValue.length > 50)
          error = "Maximum 50 characters allowed";
        break;

      /* ---------- EMAIL ---------- */
      case "email":
        if (!cleanValue.trim())
          error = "Email is required";
        else if (!emailRegex.test(cleanValue))
          error = "Enter valid email address";
        break;

      /* ---------- PHONE ---------- */
      case "phone":
        if (!cleanValue.trim())
          error = "Phone number is required";
        else if (!phoneRegex.test(cleanValue))
          error = "Enter valid 10-digit mobile number";
        break;

      /* ---------- PROJECT ---------- */
      case "project":
        if (!cleanValue.trim())
          error = "Project description is required";
        else if (cleanValue.length > 500)
          error = "Maximum 500 characters allowed";
        break;

      default:
        break;
    }

    return error;
  };


  const [validated, setValidated] = useState(false);


  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    project: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setFormErrors((prev) => ({
      ...prev,
      [name]: validateField(name, value),
    }));
  };



  const [showThankYou, setShowThankYou] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = {
      name: validateField("name", formData.name),
      email: validateField("email", formData.email),
      phone: validateField("phone", formData.phone),
      project: validateField("project", formData.project),
    };

    setFormErrors(errors);

    if (Object.values(errors).some((err) => err !== "")) return;

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("name", formData.name);
      formDataToSend.append("email", formData.email);
      formDataToSend.append("phone", formData.phone);
      formDataToSend.append("project", formData.project);

      const response = await fetch("https://formspree.io/f/xykzrwjb", {
        method: "POST",
        body: formDataToSend,
        headers: { Accept: "application/json" },
      });

      if (!response.ok) throw new Error("Formspree error");

      setFormData({ name: "", email: "", phone: "", project: "" });
      setFormErrors({ name: "", email: "", phone: "", project: "" });
      setValidated(false);
      setShowThankYou(true);

      fireThankYouTracking();
    } catch (err) {
      console.log(err);
    }
  };
  const handleClose = () => {
    setValidated(false);
    setShowThankYou(false);
    setFormData({ name: "", email: "", phone: "", project: "" });
    setFormErrors({ name: "", email: "", phone: "", project: "" });
    onClose();
  };
  const fireThankYouTracking = () => {
    if (window.gtagAlreadyFired) return;

    const script = document.createElement("script");
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11319131363";
    script.async = true;
    document.body.appendChild(script);

    const configScript = document.createElement("script");
    configScript.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'AW-11319131363');
  `;
    document.body.appendChild(configScript);

    const conversionScript = document.createElement("script");
    conversionScript.innerHTML = `
    gtag('event', 'conversion', {
      'send_to': 'AW-11319131363/g6SyCO_lsbIZEOP5sJUq',
      'value': 1.0,
      'currency': 'INR'
    });
  `;
    document.body.appendChild(conversionScript);

    window.gtagAlreadyFired = true;

    const waitForClarity = () => {
      if (typeof window.clarity === "function") {
        window.clarity("track", "ThankYouPageVisited");
      } else {
        setTimeout(waitForClarity, 100);
      }
    };

    waitForClarity();
  };
  useEffect(() => {
    if (showThankYou) {
      const timer = setTimeout(() => {
        handleClose();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [showThankYou]);

  useEffect(() => {
    if (show) {
      document.documentElement.classList.add("no-scroll");
    } else {
      document.documentElement.classList.remove("no-scroll");
    }
    return () => {
      document.documentElement.classList.remove("no-scroll");
    };
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      dialogClassName="right-slide-modal-contact"
    >
      <Modal.Body className="p-2 demo-right-contact">
        <button className="modal-close-btn" onClick={handleClose}>
          ×
        </button>
        <div className="demo-fixed-header-contact">
          <h5 className="fw-semibold text-center m-0">
            Let's Talk About Your Idea
          </h5>
        </div>
        {showThankYou ? (
          <div className="thank-you-wrapper">
            <div className="thank-you-pages">

              <FaCheck className="icons" />
              <h4>Thank you for reaching out!</h4>
              <h6>
                One of our experts will get in touch with you shortly.
              </h6>
            </div>
          </div>
        ) : (
          <Form
            noValidate
            onSubmit={handleSubmit}
            className="demo-form-scroll-contact"
          >

            {/* NAME */}
            <Form.Group className="mb-3">
              <InputGroup>
                <InputGroup.Text className="input-icon">
                  <FaUser />
                </InputGroup.Text>

                <Form.Control
                  required
                  name="name"
                  placeholder="Name *"
                  value={formData.name}
                  onChange={handleChange}
                  isInvalid={!!formErrors.name}
                />
              </InputGroup>

              {/* 🔒 FIXED HEIGHT ERROR SPACE */}
              <div className="error-space">
                {formErrors.name && (
                  <div className="invalid-feedback d-block">
                    {formErrors.name}
                  </div>
                )}
              </div>
            </Form.Group>



            <div className="row">
              {/* EMAIL */}
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <InputGroup>
                    <InputGroup.Text className="input-icon">
                      <FaEnvelope />
                    </InputGroup.Text>

                    <Form.Control
                      required
                      type="email"
                      name="email"
                      placeholder="Email *"
                      value={formData.email}
                      onChange={handleChange}
                      isInvalid={!!formErrors.email}
                    />
                  </InputGroup>

                  <div className="error-space">
                    {formErrors.email && (
                      <div className="invalid-feedback d-block">
                        {formErrors.email}
                      </div>
                    )}
                  </div>
                </Form.Group>


              </div>

              {/* PHONE */}
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <InputGroup>
                    <InputGroup.Text className="input-icon">
                      <FaPhoneAlt />
                    </InputGroup.Text>

                    <Form.Control
                      required
                      type="tel"
                      name="phone"
                      placeholder="Phone *"
                      value={formData.phone}
                      isInvalid={!!formErrors.phone}
                      inputMode="numeric"
                      pattern="[0-9]*"
                      maxLength={10}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        handleChange({
                          target: { name: "phone", value }
                        });
                      }}
                    />

                  </InputGroup>

                  <div className="error-space">
                    {formErrors.phone && (
                      <div className="invalid-feedback d-block">
                        {formErrors.phone}
                      </div>
                    )}
                  </div>
                </Form.Group>

              </div>

            </div>

            {/* PROJECT */}
            <Form.Group className="mb-4">
              <InputGroup>
                <InputGroup.Text className="input-icon textarea-icon">
                  <FaCommentDots />
                </InputGroup.Text>
                <Form.Control
                  required
                  as="textarea"
                  rows={1}
                  name="project"
                  placeholder="Tell Us About Project *"
                  value={formData.project}
                  isInvalid={!!formErrors.project}
                  onChange={(e) => {
                    handleChange(e);

                    const textarea = e.target;
                    textarea.style.height = "auto";

                    const lineHeight = 22;
                    const maxHeight = lineHeight * 4;

                    textarea.style.height =
                      Math.min(textarea.scrollHeight, maxHeight) + "px";
                  }}
                  style={{
                    resize: "none",
                    overflowY: "auto",
                    maxHeight: "88px"
                  }}
                />

              </InputGroup>

              <div className="error-space">
                {formErrors.project && (
                  <div className="invalid-feedback d-block">
                    {formErrors.project}
                  </div>
                )}
              </div>
            </Form.Group>


            <div className="demo-fixed-footer-contact">
              <button type="submit" className="pricing-btn">
                Send Message
              </button>
            </div>
          </Form>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ContactSalesModal;
